import { getDecodedUserId } from "./GeneralService";
import { DeleteRequest, GetRequest, PostRequest } from "./HttpService"; // Adjust the import path as needed

export const fetchAvailableDates = async (monthsVM) => {
  const response = await PostRequest("/Reservation/available-days", monthsVM);
  const data = await response.json();
  return data;
};

export const fetchAvailableMonths = async () => {
  return await GetRequest("/Reservation/available-months");
};

export const fetchAvailableSlots = async (date) => {
  return await GetRequest(
    "/Reservation/available-times",
    encodeURIComponent(date)
  );
};

export const getReservationInfo = async () => {
  const data = await GetRequest("/Reservation/reservation-info");
  return data;
};

export const getReserveById = async (id) => {
  return await GetRequest("/Reservation/detail", id);
};

export const reserveSlot = async (reserveDetail, authority) => {
  const respone = await PostRequest(
    "/Reservation/make-reservation",
    reserveDetail,
    authority
  );
  const data = await respone.json();

  return data;
};

export const requestPayment = async (reserveVM) => {
  const respone = await PostRequest("/Reservation/request-payment", reserveVM);
  const data = await respone.json();

  return data;
};

export const createReserveWithNoDeposite = async (reserveVM) => {
  const respone = await PostRequest(
    "/Reservation/create-reserve-with-no-deposite",
    reserveVM
  );
  const data = await respone.json();

  return data;
};

export const getUserReserve = async () => {
  const id = getDecodedUserId();
  return await GetRequest("/Reservation/user-reservations", id);
};

export const getSuccesPayments = async (filter) => {
  const respone = await PostRequest("/Payment/get-payments", filter);
  const data = await respone.json();
  return data;
};

export const getReservationsList = async (reservationPagingFilter) => {
  const respone = await PostRequest("/Reservation", reservationPagingFilter);
  const data = await respone.json();

  return data;
};

export const AddReserveSlotException = async (reserveVM) => {
  return await PostRequest("/Reservation/add-slot-exception", reserveVM);
};

export const CreateManualReservation = async (manualReserveVM) => {
  return await PostRequest("/Reservation/manual-reservation", manualReserveVM);
};

export const deleteReservation = async (reserveId) => {
  return await DeleteRequest("/Reservation", reserveId);
};

export const deleteReservation‌ByUser = async (reserveId) => {
  return await DeleteRequest("/Reservation/delete-reserve", reserveId);
};

export const getFirstAvailableSlot = async () => {
  return await GetRequest("/Reservation/first-empty-date");
};

export const getReserveSlotExceptions = async (date) => {
  const data = await GetRequest(
    "/Reservation/GetReserveSlotExceptions",
    encodeURIComponent(date)
  );
  return data;
};

export const removeReserveSlotException = async (id) => {
  return await DeleteRequest("/Reservation/RemoveReserveSlotException", id);
};
